import { css, svg } from 'lit';

// borrowed from link icon so far
const iconStyle = css`
  width: 0.9em;
  height: 0.9em;
  vertical-align: middle;
  font-size: inherit;
  margin-bottom: 0.1em;
`;

const TypescriptIcon = svg`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style="${iconStyle}"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.4835 9.0944L13.2087 7.36919C14.3803 6.19761 14.3803 4.29812 13.2087 3.12655L12.868 2.78586C11.6965 1.61429 9.79697 1.61429 8.62539 2.78586L6.45138 4.95988C5.2798 6.13145 5.2798 8.03094 6.45138 9.20252L6.79206 9.5432C7.00515 9.75629 7.24231 9.93062 7.4948 10.0662L8.03363 9.52736C8.12106 9.43993 8.1859 9.33847 8.22816 9.23022C7.97957 9.13619 7.74646 8.9891 7.54631 8.78896L7.20562 8.44827C6.45061 7.69326 6.45061 6.46914 7.20562 5.71412L9.37964 3.54011C10.1347 2.78509 11.3588 2.78509 12.1138 3.5401L12.4545 3.88079C13.2095 4.63581 13.2095 5.85992 12.4545 6.61494L11.3183 7.75111C11.4483 8.18806 11.5034 8.64257 11.4835 9.0944Z"
    fill="#6880FF"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.5099 6.89898L2.78469 8.62419C1.61311 9.79576 1.61311 11.6953 2.78469 12.8668L3.12537 13.2075C4.29695 14.3791 6.19644 14.3791 7.36802 13.2075L9.54203 11.0335C10.7136 9.86193 10.7136 7.96243 9.54203 6.79086L9.20135 6.45017C8.98826 6.23709 8.75109 6.06276 8.49861 5.92718L7.95978 6.46601C7.87235 6.55344 7.80751 6.65491 7.76525 6.76315C8.01384 6.85719 8.24695 7.00427 8.4471 7.20442L8.78779 7.54511C9.5428 8.30012 9.5428 9.52424 8.78779 10.2793L6.61377 12.4533C5.85875 13.2083 4.63463 13.2083 3.87962 12.4533L3.53893 12.1126C2.78392 11.3576 2.78392 10.1335 3.53893 9.37844L4.6751 8.24227C4.54508 7.80531 4.49002 7.35081 4.5099 6.89898Z"
    fill="#6880FF"
  />
</svg>`;

export const IconMap = new Map([['typescript', TypescriptIcon]]);

export const SearchIcon = svg`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0917 15.9085L14 12.8418C15.2001 11.3455 15.7812 9.44625 15.624 7.53458C15.4668 5.62292 14.5831 3.84415 13.1546 2.56403C11.7261 1.28392 9.8615 0.599756 7.9441 0.652223C6.0267 0.70469 4.20226 1.4898 2.84595 2.84612C1.48963 4.20243 0.704522 6.02686 0.652055 7.94427C0.599588 9.86167 1.28375 11.7263 2.56387 13.1548C3.84398 14.5832 5.62275 15.4669 7.53441 15.6242C9.44608 15.7814 11.3453 15.2002 12.8417 14.0002L15.9083 17.0668C15.9858 17.1449 16.078 17.2069 16.1795 17.2492C16.2811 17.2915 16.39 17.3133 16.5 17.3133C16.61 17.3133 16.7189 17.2915 16.8205 17.2492C16.922 17.2069 17.0142 17.1449 17.0917 17.0668C17.2419 16.9114 17.3258 16.7038 17.3258 16.4877C17.3258 16.2716 17.2419 16.0639 17.0917 15.9085ZM8.16666 14.0002C7.01294 14.0002 5.88512 13.658 4.92584 13.0171C3.96655 12.3761 3.21888 11.4651 2.77737 10.3992C2.33585 9.33325 2.22034 8.16036 2.44542 7.0288C2.6705 5.89725 3.22607 4.85785 4.04187 4.04204C4.85768 3.22624 5.89708 2.67066 7.02864 2.44558C8.16019 2.2205 9.33308 2.33602 10.399 2.77753C11.4649 3.21904 12.3759 3.96672 13.0169 4.926C13.6579 5.88529 14 7.01311 14 8.16683C14 9.71393 13.3854 11.1977 12.2915 12.2916C11.1975 13.3856 9.71376 14.0002 8.16666 14.0002Z" fill="#888A9E"/>
</svg>
`;
